/**
 * BATCH UPLOAD COMPONENT ENTRY POINT
 *
 * The main component is a wrapper which encapsulates other components. Also,
 * the router inserts the required components here depending on the URL.
 *
 * @version 0.1
 */

import React from 'react';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import reduxStore from './../../reduxStore';
import actions from './BatchUpload.actions';
import api from './../../api/Common.api';
import commonActions from './../../api/Common.actions';
import headerActions from './../../reusable/Header/Header.actions';
import BatchUploadModals from './submodules/Modals/BatchUpload.modals.jsx';
import PreviewPage from './submodules/PreviewPage/PreviewPage.index.jsx';
import ErrorPage from './submodules/ErrorPage/ErrorPage.index.jsx';
import InitialStage from './submodules/InitialStage/InitialStage.index.jsx';
import Spinnable from './../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';
import { EMPTY_COMPANIES_XLSL } from './../../constants';

class BatchUpload extends React.Component {

    constructor(props) {
        super(props);
        this.state = reduxStore.getState();
        this.fileSelected = this.fileSelected.bind(this);
        this.cancelUpload = this.cancelUpload.bind(this);
    }

    componentWillMount() {

        this.props.spinner.showSpinner();

        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState());
            }
        );

        api.getPendingUpload()
            .then((response) => {
                commonActions.updatePendingUploads(response);
                if (this.state.user.pendingUpload.uploadId &&
                    this.state.user.pendingUpload.count !== 0
                    && this.state.user.pendingUpload.count !== 'N/A') {
                    actions.uploadSuccess(this.state.user.pendingUpload.uploadId);
                    actions.checkFormattingEntriesCount(this.state.user.pendingUpload.uploadId);
                } else {
                    if (this.props.location.pathname === "/upload") {
                        headerActions.updateHeader('batchUpload');
                    } else {
                        headerActions.updateHeader('getStartedNewUser');
                    }
                    reduxStore.dispatch({type: "UPLOAD_INITIAL_PHASE"});
                }
            })
            .then(() => {
                this.props.spinner.hideSpinner();
            })
            .catch((error) => {
                if (this.props.location.pathname === "/upload") {
                    headerActions.updateHeader('batchUpload');
                } else {
                    headerActions.updateHeader('getStartedNewUser');
                }
                reduxStore.dispatch({type: "UPLOAD_INITIAL_PHASE"});
                utils.logError(error, 'api.getPendingUpload(): ');
                this.props.spinner.hideSpinner();
            });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {

        return (
            <div className="upload-wizard">

                {this.showStage()}

                <BatchUploadModals stage={this.state.batchUpload.stage}
                       file={this.state.batchUpload.file}
                       handleUpload={ actions.handleUpload}
                       uploadSelectedFile={this.fileSelected}
                       cancelUpload={this.cancelUpload}
                />
            </div>
        );

    }

    showStage() {

        if (this.state.batchUpload.stage == "success") {
            return (
                <div className="super-container">
                    <PreviewPage/>
                </div>
            );
        } else if (this.state.batchUpload.stage == "failure") {
            return (
                <div className="super-container">
                    <ErrorPage triggerSelectFile={this.triggerSelectFile}/>
                </div>
            );
        } else {

            return (
                <InitialStage
                    stage={this.state.batchUpload.stage}
                    downloadFile={this.downloadFile}
                    selectFile={this.triggerSelectFile}
                    fileSelected={this.fileSelected.bind(this)}
                    helpUrlRoot={this.state.user.helpUrlRoot}
                    isReviewButtonActive={this.state.batchUpload.inactiveEntities > 0}
                />
            );

        }

    }

    downloadFile() {

        xhr.get({
            url: '/api/user/ping'
        }).then(() => {
            window.open(EMPTY_COMPANIES_XLSL, '_self');
        }).catch((error) => {
            xhr.handleAllErrors(error);
        });

    }

    fileSelected(evt) {
        actions.uploadFileSelected(evt.target.files[0]);
    }

    resetUploadWizard() {
        document.getElementById('batch-upload-form').reset();
    }

    cancelUpload() {
        actions.cancelUpload();
        this.resetUploadWizard();
        this.triggerSelectFile();
    }

    triggerSelectFile() {
        setTimeout(function () {
            let fileInput = document
                .getElementsByClassName('upload-wizard__upload-input')[0];
            fileInput.click();
        }, 0);
    }

}

export default Spinnable(BatchUpload);



// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/BatchUpload.index.jsx